import { onDomReady } from '../../JavaScript/on-dom-ready';

const initializeEqsNewsTeaser = (eqsNewsTeaser: Element) => {
      const navLinks: NodeListOf<HTMLAnchorElement> = eqsNewsTeaser.querySelectorAll(".eqsnewsteaser-navigation__link");
      const teaserItems: NodeListOf<HTMLDivElement> = eqsNewsTeaser.querySelectorAll(".eqsnewsteaser-teaser__item");

      navLinks.forEach(link => {
        link.addEventListener("click", (event) => {
          event.preventDefault();
          const selectedRel = link.getAttribute("data-rel");
          if (!selectedRel) return;

          // Entferne 'active' von allen Links im aktuellen Container
          navLinks.forEach(nav => nav.classList.remove("button--active"));

          // Füge 'active' zum angeklickten Link hinzu
          link.classList.add("button--active");

          // Alle Teaser-Items im aktuellen Container verstecken
          teaserItems.forEach(item => item.classList.add("hidden"));

          // Das korrespondierende Teaser-Item anzeigen
          eqsNewsTeaser.querySelector(`.eqsnewsteaser-teaser__item[data-rel='${selectedRel}']`)?.classList.remove("hidden");
        });
      });
};

onDomReady(() => {
  for (const eqsNewsTeaser of document.getElementsByClassName('ce--sitepackagesaf_eqsnewsteaser')) {
    initializeEqsNewsTeaser(eqsNewsTeaser);
  }
});
